import LabRepository from "./LabRepository";

const resource = "/service-instruction";
export default {

  create(payload) {
    return LabRepository.post(resource, payload);
  },

  update(id, payload) {
    return LabRepository.put(`${resource}/${id}`, payload);
  },

};
